import { render, staticRenderFns } from "./matrixPage.vue?vue&type=template&id=97a6a58c&scoped=true"
import script from "./matrixPage.vue?vue&type=script&lang=js"
export * from "./matrixPage.vue?vue&type=script&lang=js"
import style0 from "./matrixPage.vue?vue&type=style&index=0&id=97a6a58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a6a58c",
  null
  
)

export default component.exports